import { de } from './de';
import { en } from './en';
import type { Locale, Strings } from './types';

export type {
  Locale,
  Strings,
  ToneKey,
  GenderKey,
  PathKey,
  ArchetypeKey,
  BoundaryCategoryKey,
  BoundaryLevelKey,
  MoodKey,
  ToneStrings,
  GenderStrings,
  PathStrings,
  ArchetypeStrings,
  DailyGuidancePool,
} from './types';

export const STRINGS_BY_LOCALE: Record<Locale, Strings> = { de, en };

export const SUPPORTED_LOCALES: readonly Locale[] = ['de', 'en'];
export const DEFAULT_LOCALE: Locale = 'de';

export function getStrings(locale: Locale): Strings {
  return STRINGS_BY_LOCALE[locale];
}

/**
 * Pick the best locale for the user. Looks at the BCP-47 language tag and
 * falls back to {@link DEFAULT_LOCALE} when nothing matches. Pure — caller
 * supplies the candidate string so this is trivially testable.
 */
export function resolveLocale(candidate: string | undefined | null): Locale {
  if (!candidate) return DEFAULT_LOCALE;
  const head = candidate.toLowerCase().split(/[-_]/)[0];
  if (head === 'de') return 'de';
  if (head === 'en') return 'en';
  return DEFAULT_LOCALE;
}

/**
 * Replace `{key}` placeholders in a string with values from `vars`.
 * Missing keys are left untouched — easier to spot during development than
 * silent blanks.
 */
export function interpolate(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    const v = vars[key];
    return v === undefined ? match : String(v);
  });
}
